import { Box } from '@mui/material'
import { ReactComponent as RequestDetails } from '../../../../images/RequestDetails.svg'
import UseTranslation from '../../../../hooks/UseTranslation'
import {
  decodeHtmlString, formatCurrency, getFormattedDateFromYearMonth,
} from '../../../../utils/helpers'
import TitleWithIcon from '../../../../components/Cards/helpers/TitleWithIcon'
import TitleWithInfo from '../../../../components/Cards/helpers/TitleWithInfo'
import AttachmentDownloader from '../../../../components/Cards/helpers/AttachmentDownloader'

const LoanDetailsRequest = ({ details, title }) => {
  const { t } = UseTranslation()
  const currency = 'EGP'
  return (
    <Box sx={styles.detailsContainer(title)}>
      {title && (
      <TitleWithIcon
        title={title ?? t?.['Request Details']}
        icon={<RequestDetails />}
        customStyle={styles.stackFlex}
        textVariant="heading4"
        iconSize="sm"
      />
      )}
      <Box sx={styles.detailsBox(title)}>
        <Box sx={styles.detailsData}>

          <TitleWithInfo
            title={`${t?.['Request Type']}`}
            info={details?.source?.name}
            customStyle={styles.detailsInfo}
          />
          {details?.source?.loanValue && (
            <TitleWithInfo
              title={`${t?.['Loan Value']}`}
              info={formatCurrency(details?.source?.loanValue, currency)}
              customStyle={styles.detailsInfo}
            />
          )}

          {details?.source?.startYear && details?.source?.startMonth && (
          <TitleWithInfo
            title={`${t?.['Start Date']}`}
              info={
                getFormattedDateFromYearMonth(details?.source?.startYear, details?.source?.startMonth) || '-- -- --'
              }
            customStyle={styles.detailsInfo}
          />
          )}

          {details?.source?.totalInstallment && (
          <TitleWithInfo
            title={`${t?.Installments}`}
            info={details?.source?.totalInstallment}
            customStyle={styles.detailsInfo}
          />
          )}
          {details?.source?.monthValue && (
          <TitleWithInfo
            title={`${t?.['Monthly Value']}`}
            info={formatCurrency(details?.source?.monthValue, currency)}
            customStyle={styles.detailsInfo}
          />
          )}

          {details?.attachment_group_id && (
          <TitleWithInfo
            title={`${t?.Attachments}`}
            info={(
              <AttachmentDownloader
                attachments={details?.attachment_group_id}
              />
              )}
            customStyle={styles.detailsInfo}
          />
          )}

        </Box>
        <TitleWithInfo
          title={`${t?.Comment}`}
          info={decodeHtmlString(details?.source?.comment || '-- -- --')}
          customStyle={styles.commentInfo}
        />
      </Box>
    </Box>

  )
}

export const styles = {
  detailsContainer: (title) => ({
    padding: title ? { xs: '10px 0px', sm: '20px' } : { xs: '0px', sm: '0px 20px' },
  }),
  stackFlex: {
    display: 'flex',
    alignItems: 'center',
    fontSize: { xs: '14px', sm: '18px' },
    gap: '10px',
    '& svg': {
      width: { xs: '15px', sm: '25px' },
      height: { xs: '15px', sm: '25px' },
    },
    '& span': {
      marginLeft: '0px',
    },
  },
  detailsBox: (title) => ({
    p: title ? { xs: '10px 0', md: '20px 20px 0px' } : { xs: '0px', md: '0px 20px' },
  }),

  detailsData: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' },
    gridAutoFlow: 'row',
    columnGap: '172px',
  },
  detailsInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: { xs: 'flex-start', md: 'center' },
    width: '100%',
    my: '10px',
    h5: {
      margin: '0px',
      maxWidth: { xs: '140px', md: '200px' },
      fontWeight: 350,
      fontSize: { xs: '13px', md: '14px' },
      lineHeight: { xs: '22px', md: '27.9px' },
      color: '#92929D',
    },
    h6: {
      maxWidth: { xs: '100%', md: '280px' },
      margin: '0px',
      fontWeight: 350,
      fontSize: { xs: '14px', md: '14px' },
      lineHeight: '27.9px',
      overflowWrap: 'break-word',
    },
  },
  commentInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    my: { xs: '10px', md: '10px' },
    h5: {
      margin: '0px',
      width: '20%',
      maxWidth: { xs: '140px', md: '200px' },
      fontWeight: 350,
      fontSize: { xs: '13px', md: '14px' },
      lineHeight: { xs: '22px', md: '27.9px' },
      color: '#92929D',
    },
    h6: {
      width: '80%',
      maxWidth: { xs: '180px', md: 'unset' },
      margin: '0px',
      fontWeight: 350,
      textAlign: { xs: 'right', md: 'left' },
      fontSize: { xs: '14px', md: '14px' },
      lineHeight: '27.9px',
      overflowWrap: 'break-word',
      '& p': {
        margin: '0px',

      },
    },
  },
}

export default LoanDetailsRequest
